import { render, staticRenderFns } from "./Pattini.vue?vue&type=template&id=08ccb116"
import script from "./Pattini.vue?vue&type=script&lang=js"
export * from "./Pattini.vue?vue&type=script&lang=js"
import style0 from "./Pattini.vue?vue&type=style&index=0&id=08ccb116&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports